import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const BackLinkWrapper = styled.div`
  margin-bottom: 8px;
`;
